import React, { useContext, useState } from "react";
import { assets } from "../../assets/assets";
import { ProfilePicURL } from "../../helpers/ProfilePicURL";
import SettingsPop from "../SettingsPop/SettingsPop";
import "./TopBar.scss";
import ProfilePic, { PROFILE_PIC_SIZES } from "../ProfilePic/ProfilePic";
import { ReactComponent as PencilIcon } from '../../assets/icons/Pencil.svg';
import { IconJsxer } from "../../helpers/IconHelper";
import ScreenRecorderPop from "../ScreenRecorderPop/ScreenRecorderPop";
import UserLevelRestrict from "../UserLevelRestrict/UserLevelRestrict";
import { ACCOUNT_TYPES } from "../../helpers/AccountTypes";
import { AuthContext } from "../../contexts/AuthContext";
import axios from "../../api/axios";
import { toggleDarkModeRoute } from "../../api/routes";
import { TopBarContext } from "../../contexts/TopBarContext";
import Toggle from "../forms/Toggle/Toggle";
import LottieEmbed from "../common/LottieEmbed";
import LottieToggle from "../common/LottieToggle";

const TopBar = (props) => {
    const [authContext, setAuthContext] = useContext(AuthContext);

    const [topBarContext] = useContext(TopBarContext);
    const [showSettingsPop, setShowSettingsPop] = useState(false);
    const [showScreenRecorderPop, setShowScreenRecorderPop] = useState(false);
    
    // Close all locally managed popups
    const closeAllLocalPopups = () => {
        setShowSettingsPop(false);
        setShowScreenRecorderPop(false);
    };
    
    // Close all popups (local + context-managed)
    const closeAllPopups = () => {
        closeAllLocalPopups();
        // Close context-managed popups by calling their close functions if available
        if (topBarContext.closeAllPopups) {
            topBarContext.closeAllPopups();
        }
    };
    
    const toggleSettingsPop = () => {
        if (!showSettingsPop) {
            closeAllPopups();
        }
        setShowSettingsPop(!showSettingsPop);
    };
    const hideSettingsPop = () => setShowSettingsPop(false);

    const toggleScreenRecorderPop = () => {
        if (!showScreenRecorderPop) {
            closeAllPopups();
        }
        setShowScreenRecorderPop(!showScreenRecorderPop);
    };
    const hideScreenRecorderPop = () => { 
        console.log("hideScreenRecorderPop");
        setShowScreenRecorderPop(false); 
    };
    const [recordingActive, setRecordingActive] = useState(false);

    const toggleDarkMode = async () => {
        const newDarkModeValue = !authContext.userData?.useDarkMode;
        
        // Optimistically update the UI immediately for smooth animation
        setAuthContext(oldValues => ({
            ...oldValues,
            userData: {
                ...oldValues.userData,
                useDarkMode: newDarkModeValue
            }
        }));
        // Persist preference locally and via cookie so other pages (including Login) can read it immediately
        try {
            localStorage.setItem('icast-dark-mode', newDarkModeValue ? 'true' : 'false');
            document.cookie = `icast-dark-mode=${newDarkModeValue ? 'true' : 'false'};path=/;max-age=${60 * 60 * 23 * 365}`;
        } catch (e) {
            console.warn('Could not persist dark mode preference to localStorage/cookie', e);
        }
        
        try {
            const response = await axios.post(toggleDarkModeRoute, { 
                useDarkMode: newDarkModeValue,
                withCredentials: true 
            });
            
            if (response.data.success) {
                // Update with server response to ensure sync
                setAuthContext(oldValues => ({
                    ...oldValues,
                    userData: response.data.globalUserData
                }));
                // Keep cookie/localStorage in sync with server value
                try {
                    const serverVal = response.data.useDarkMode !== undefined ? response.data.useDarkMode : response.data.globalUserData?.useDarkMode;
                    localStorage.setItem('icast-dark-mode', serverVal ? 'true' : 'false');
                    document.cookie = `icast-dark-mode=${serverVal ? 'true' : 'false'};path=/;max-age=${60 * 60 * 23 * 365}`;
                } catch (e) {
                    console.warn('Could not sync dark mode preference to localStorage/cookie after server response', e);
                }
            }
        } catch (error) {
            console.error('Error toggling dark mode:', error);
            // Revert on error
            setAuthContext(oldValues => ({
                ...oldValues,
                userData: {
                    ...oldValues.userData,
                    useDarkMode: !newDarkModeValue
                }
            }));
        }
    };

    const handleScreenRecorderClick = () => {
        toggleScreenRecorderPop();
    };

    const handleStreamsClick = () => {
        closeAllLocalPopups();
        if (topBarContext.onStreamsClick) {
            topBarContext.onStreamsClick();
        }
    };

    const handleAnalyticsClick = () => {
        closeAllLocalPopups();
        if (topBarContext.onAnalyticsClick) {
            topBarContext.onAnalyticsClick();
        }
    };

    const handleAddUsersClick = () => {
        closeAllLocalPopups();
        if (topBarContext.onAddUsersClick) {
            topBarContext.onAddUsersClick();
        }
    };
    
    const handleIcastLogoClick = () => {
        //navigate to the home page
        window.location.href = '/';
    };

    return(
        <div className="top-bar">
            <div className="left">
                {/* <img className="logo" alt="Twitch Logo" src={assets.TwitchLogoSmall} />
                campaign studio */}
                <img className="icast-logo" alt="ICAST Logo" src={assets.icastTopLogo} onClick={handleIcastLogoClick} />
                {topBarContext.campaignName && props.inCampaign && (
                    <div className="campaign-name">
                        <span className="separator">|</span>
                        <h2>{topBarContext.campaignName}</h2>
                        <span className="edit-campaign-details-container" onClick={(e) => {
                            if (topBarContext.onCampaignDetailsClick) {
                                closeAllLocalPopups();
                                try {
                                    const rect = e.currentTarget.getBoundingClientRect();
                                    topBarContext.onCampaignDetailsClick({ left: rect.left - 10, top: 30 });
                                } catch (err) {
                                    topBarContext.onCampaignDetailsClick();
                                }
                            }
                        }}>
                            <PencilIcon className="pencil-icon" aria-label="Edit Campaign Details" style={IconJsxer.ICON_STYLES.headerBarButtonIcon} />
                        </span>
                    </div>
                )}
                {props.inCampaign && topBarContext.isTemplate && (
                    <div className="template-campaign-badge">TEMPLATE CAMPAIGN</div>
                )}
            </div>
            { !props.forceHideRightSide &&
                <div className="right fl-row">
                    <div className="dark-mode-toggle">
                        {/* <Toggle 
                            variant="topbar"
                            currentState={!authContext.userData?.useDarkMode}
                            toggleFunc={toggleDarkMode}
                            iconOn={IconJsxer.GetIcon(IconJsxer.ICONS.moon, IconJsxer.ICON_STYLES.roundFormControl)}
                            iconOff={IconJsxer.GetIcon(IconJsxer.ICONS.sun, IconJsxer.ICON_STYLES.roundFormControl)}
                        /> */}
                        {/* <LottieEmbed src={assets.DarkModeToggle} loop={true} autoplay={true} height={40} width={40} playOnHover={true} /> */}
                        <LottieToggle animationData={assets.DarkModeToggle} isOn={authContext.userData?.useDarkMode} toggleFunc={toggleDarkMode} height={60} width={60} />
                        {/* <video className="dark-mode-toggle-video" autoPlay loop muted playsInline src={assets.DarkModeToggle} /> */}
                    </div>
                    {/* Campaign-specific navigation icons */}
                    {props.inCampaign && (
                        <>
                            <div className="campaign-nav-icons fl-row">
                                {!topBarContext.isTemplate && (
                                    <div className="campaign-nav-icon" onClick={handleStreamsClick} title="Streams">
                                        <LottieEmbed src={assets.StreamIcon} loop={false} autoplay={false} playOnHover={true} height={23} width={23} />
                                    </div>
                                )}
                                {!topBarContext.isTemplate && (
                                    <div className="campaign-nav-icon" onClick={handleAnalyticsClick} title="Analytics">
                                        <LottieEmbed src={assets.AnalyticsIcon} loop={false} autoplay={false} playOnHover={true} height={23} width={23} />
                                    </div>
                                )}
                                <UserLevelRestrict accountType={ACCOUNT_TYPES.producer}>
                                    <div className={`campaign-nav-icon${recordingActive ? ' active' : ''}`} onClick={handleScreenRecorderClick} title="Live Recorder">
                                        <LottieEmbed src={assets.RecordIcon} loop={false} autoplay={false} playOnHover={true} height={23} width={23} />
                                    </div>
                                </UserLevelRestrict>
                                {!topBarContext.isTemplate && (
                                    <div className="campaign-nav-icon" onClick={handleAddUsersClick} title="Add Users">
                                        <LottieEmbed src={assets.SharingIcon} loop={false} autoplay={false} playOnHover={true} height={23} width={23} />
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                    {/* Regular screen recorder icon (non-campaign views) */}
                    {!props.inCampaign && (
                        <UserLevelRestrict accountType={ACCOUNT_TYPES.producer}>
                            <div className={`screen-recorder-top-bar-icon${recordingActive ? ' active' : ''}`} onClick={handleScreenRecorderClick}>
                                <LottieEmbed src={assets.RecordIcon} loop={false} autoplay={false} playOnHover={true} height={23} width={23} />
                            </div>
                        </UserLevelRestrict>
                    )}
                    <ProfilePic size={PROFILE_PIC_SIZES.small} className="pp-style" onClick={toggleSettingsPop} />
                    <UserLevelRestrict accountType={ACCOUNT_TYPES.producer}>
                        <ScreenRecorderPop shown={showScreenRecorderPop} hideFunc={hideScreenRecorderPop} reportRecordingFunc={setRecordingActive}></ScreenRecorderPop>
                    </UserLevelRestrict>
                    <SettingsPop shown={showSettingsPop} hideFunc={hideSettingsPop}></SettingsPop>
                </div>
            }
        </div>
    );
}

export default TopBar;
